import { EventsMapper, createMiddleware, Target } from 'redux-beacon'
import { getType } from 'typesafe-actions'
import { AnyAction } from 'redux'

import { FullStackTrackable } from '@chegg/optimizely-sdk'
import { ActionTypes } from '../user/constants'
import { login } from '../user/actions'
import { citationCreateSucceeded } from '../citation/actions'
import { track } from './optimizely'

import { freeTrialStartEvent, accountCreatedEvent, citationCreatedEvent } from './events'

export const optimizelyTarget = (): Target => (events: FullStackTrackable[]) => {
  events.forEach((event) => {
    track(event)
  })
}

export const eventsMap: EventsMapper = (action: AnyAction) => {
  switch (action.type) {
    case getType(citationCreateSucceeded):
      return citationCreatedEvent
    case getType(login):
      return accountCreatedEvent
    case ActionTypes.UPGRADE_SUCCESS:
    case ActionTypes.UPGRADE:
      return freeTrialStartEvent
    default:
      return []
  }
}

export const opMiddleware = createMiddleware(eventsMap, optimizelyTarget())
